<template>
	<joy-page :joyPageStatus="joyPageStatus">
		<van-cell title="微信号"icon="comment" :value="listData.wechat"></van-cell>
		<van-cell title="电话号码" icon="phone" :value="listData.phone"></van-cell>
		
	</joy-page>
</template>

<script>
	export default{
		created() {
			this.loadData();
		},
		data(){
			return{
				joyPageStatus:'',
				listData:'',
			}
		},
		methods:{
			loadData(){
				try{
					this.joyPageStatus = 'loading';
					this.$axios.get('site/contact').then(res => {
						this.joyPageStatus = 'success';
						if(res.data.code==200){
							this.listData=res.data.data;
							this.listData.wechat=this.listData.wechat || '暂无';
							this.listData.phone=this.listData.phone || '暂无';
						}else{
							this.$toast.fail(res.data.msg)
						}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
		},
		
	}
	
</script>

<style scoped="scoped">
</style>
